// @ts-expect-error: implicitly has an 'any' type
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn';
import enUsLocale from 'date-fns/locale/en-US';

const defaultMonthValues = [
  'មករា',
  'កុម្ភៈ',
  'មីនា',
  'មេសា',
  'ឧសភា',
  'មិថុនា',
  'កក្កដា',
  'សីហា',
  'កញ្',
  'តុលា',
  'វិច្ឆិកា',
  'ធ្',
];

const monthValues = {
  narrow: defaultMonthValues,
  abbreviated: defaultMonthValues,
  wide: defaultMonthValues,
};

const defaultDayValues = ['អាទិត្យ', 'ច័ន្', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្', 'សៅរ៍'];

const dayValues = {
  narrow: defaultDayValues,
  short: defaultDayValues,
  abbreviated: defaultDayValues,
  wide: defaultDayValues,
};

const defaultDayPeriodValues = {
  am: 'ព្រឹក',
  pm: 'រសៀល',
  midnight: 'mi',
  noon: 'n',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night',
};

const dayPeriodValues = {
  narrow: defaultDayPeriodValues,
  abbreviated: defaultDayPeriodValues,
  wide: defaultDayPeriodValues,
};

const defaultFormattingDayPeriodValues = {
  am: 'ព្រឹក',
  pm: 'រសៀល',
  midnight: 'mi',
  noon: 'n',
  morning: 'in the morning',
  afternoon: 'in the afternoon',
  evening: 'in the evening',
  night: 'at night',
};

const formattingDayPeriodValues = {
  narrow: defaultFormattingDayPeriodValues,
  abbreviated: defaultFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues,
};

export const localize: Locale['localize'] = {
  ordinalNumber: enUsLocale.localize!.ordinalNumber,
  era: enUsLocale.localize!.era,
  quarter: enUsLocale.localize!.quarter,
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
};
